import { VDBText } from "@components/atoms";
import React from "react";
import { View, StyleSheet } from "react-native";

type StrikePriceProps = {
  value: string;
  textColor: string;
  lineColor?: string;
  typography: any;
  numberOfLines?: number;
  align?: "left" | "center" | "right";
};

const StrikePrice: React.FC<StrikePriceProps> = ({
  value,
  textColor,
  lineColor = "#999",
  typography,
  numberOfLines = 1,
  align = "left",
}) => {
  return (
    <View
      style={[
        styles.container,
        align === "right" && { alignSelf: "flex-end" },
        align === "center" && { alignSelf: "center" },
      ]}
    >
      <VDBText
        color={textColor}
        type={typography}
        numberOfLines={numberOfLines}
        textAlign={align}
      >
        {value}
      </VDBText>

      <View style={[styles.strikeLine, { backgroundColor: lineColor }]} />
    </View>
  );
};

export default StrikePrice;

const styles = StyleSheet.create({
  container: {
    position: "relative",
  },
  strikeLine: {
    position: "absolute",
    left: 0,
    right: 0,
    top: "50%",
    height: 1.2,
  },
});
